import Downloader from "js-file-downloader";

function fileDownload(fileUrl) {
  console.log("fileDownload");
  new Downloader({
    url: location.origin + "/static" + fileUrl
  })
    .then(() => {
      console.log("fileDownload ok");
    })
    .catch(err => {
      console.log("fileDownload err");
      console.log("fileDownload url = " + fileUrl);
      console.log("fileDownload err = " + err);
    });
}

export const getThumbIcon = fileName => {
  var iconName = "";
  var fileExt = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();

  switch (fileExt) {
    case ".pptx":
    case ".ppt":
      {
        iconName = "ppt.png";
      }
      break;
    case ".xlsx":
    case ".xls":
      {
        iconName = "xls.png";
      }
      break;
    case ".docx":
    case ".doc":
      {
        iconName = "doc.png";
      }
      break;
    case ".ai":
      {
        iconName = "ai.png";
      }
      break;
    case ".bmp":
      {
        iconName = "bmp.png";
      }
      break;
    case ".xpk":
    case ".asm":
    case ".udf":
    case ".afm":
    case ".fem":
    case ".bip":
    case ".stl":
    case ".step":
    case ".sat":
    case ".x_t":
    case ".jt":
    case ".3dm":
    case ".dwg":
    case ".dxf":
    case ".sldprt":
    case ".model":
    case ".igs":
    case ".ipt":
    case ".jt":
    case ".3dm":
    case ".prt":
    case ".3ds":
    case ".cad":
      {
        iconName = "cad.png";
      }
      break;
    case ".gif":
      {
        iconName = "gif.png";
      }
      break;
    case ".jpeg":
    case ".jpg":
      {
        iconName = "jpg.png";
      }
      break;
    case ".pdf":
      {
        iconName = "pdf.png";
      }
      break;
    case ".png":
      {
        iconName = "png.png";
      }
      break;
    case ".zip":
      {
        iconName = "zip.png";
      }
      break;
    case ".psd":
      {
        iconName = "psd.png";
      }
      break;
    case ".js":
      {
        iconName = "js.png";
      }
      break;
    case ".css":
      {
        iconName = "css.png";
      }
      break;
    case ".html":
      {
        iconName = "html.png";
      }
      break;
    case ".md":
    case ".txt":
      {
        iconName = "txt.png";
      }
      break;
    default:
      iconName = "unknown.png";
  }
  return require("../../assets/img/icon/" + iconName);
};

export default {
  fileDownload
};



// WEBPACK FOOTER //
// ./src/components/common/util.js